import {AlertTypes} from '@/models/AlertTypes';

export default class Alert {
  public show: boolean = false;
  public message: string = '';
  public type: string = AlertTypes.Success;
  public dismissible: boolean = true;

  constructor(
    message= '',
    type: string = AlertTypes.Success,
    show = false,
    dismissible = true,
  ) {
  this.show = show;
  this.message = message;
  this.type = type;
  this.dismissible = dismissible;
  }
}
